import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DeviceService } from 'src/app/services/devices/device.service';
import { isRelaySchedulerDevice, getRelayDeviceImage } from 'src/app/services/devices/device-type.util';
import { ModalService } from 'src/app/services/modal/modal.service';
import { ConnectorState } from 'src/assets/js/constants';
import { TranslateService } from '@ngx-translate/core';
import { LoadingPopupComponent } from 'src/app/components/ui/loading-popup/loading-popup.component';
import { DashboardService } from 'src/app/services/dashboard/dashboard.service';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'app-show-group',
    templateUrl: './show-group.component.html',
    styleUrls: ['./show-group.component.scss'],
    standalone: false
})
export class ShowGroupComponent implements OnInit, OnChanges {

  @Input() allCtm = false;

  breadCrumbs: any;

  group: any;
  @Input() data: any = {};
  linkedDevices: any[] = [];
  allStates = ConnectorState;
  modalLoad: any;
  updateStatus?: number;
  status: any[] = [];
  showStatus = false;
  modal: any;
  ampacity = 32;
  power = 0;
  url = '';
  port = 0;
  @Input() loading = true;
  confirm = {
    power: false,
    reset: false,
    ocpp: false,
    rfid: false,
    wifi: false,
    password: false,
    cards: false,
    role: false
  };

  selectAll = false;
  selectedDevices: any[] = [];

  chooseCfg = 'power';
  rfidEnabled = 0;
  rfidMode = 0;
  eocMode: 'any' | 'own' | string = 'own';
  messageDelCards = false;
  cardsMode: 'upload' | 'delete' | string = 'upload';
  ssid = '';
  wifiPass = '';
  newPass = '';
  accessPoint = 1;
  addBoxId = false;
  master = '';
  masterName = '';
  next = 'master';
  slaves: any[] = [];
  chargeError?: number;
  interface = 1;
  powerLine?: number;
  powerR?: number;
  powerS?: number;
  powerT?: number;
  ip = '';
  slave = true;

  file: File;
  tagList: any;

  dataSource: MatTableDataSource<any>;
  displayedColumns: string[] = ['icon', 'estado', 'nombre', 'rol', 'firmware', 'toma1', 'toma2', 'potencia', 'spl', 'config', 'acciones'];
  displayedColumnsANC2: string[] = ['icon', 'estado', 'nombre', 'rol', 'firmware', 'toma1', 'potencia', 'config', 'acciones'];
  displayedColumnsXLUM: string[] = ['icon', 'estado', 'nombre', 'rol', 'firmware', 'toma1', 'toma2', 'toma3', 'toma4', 'potencia', 'config', 'acciones'];
  displayedColumnsANC1: string[] = ['icon', 'estado', 'nombre', 'rol', 'firmware', 'toma1', 'toma2', 'config', 'acciones'];
  sortField = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  orginalName: any[] = [];
  fileSelected = false;
  connectorsMennekes: any[] = [];
  currentConn1: number;
  currentConn2: number;
  userRole = '';
  roles = [
    {value: 'all', viewValue: 'All'},
    {value: 'read', viewValue: 'Read'},
    {value: 'write', viewValue: 'Write'},
    {value: 'owner', viewValue: 'Owner'},
  ];
  selectedRole = '';
  is3Ph = false;

  constructor(private _router: Router,
              private _modal: ModalService,
              private _devices: DeviceService,
              private route: ActivatedRoute,
              private _translate: TranslateService,
              private _dashboard: DashboardService
            ) {              }


  ngOnInit() {}

  async ngOnChanges() {
    console.log('this data devices', this.data);
    this._devices.getActiveDeviceInfo()
    //         .subscribe(data => {

    //           console.log('active device info ', data);
    // })
    if(!this.loading){
      const devices = Array.isArray(this.data?.devices) ? this.data.devices : [];
      console.log('devices show-group ', devices);
      this.allCtm = devices.length > 0 && devices.every(device => typeof device?.serial === 'string' && device.serial.includes('CTM'));

      this.status=[];
      await Promise.all(
        this.data.devices.map(async (device) => {
          console.log('device ',device);
          this.status.push({serial: device.serial, status: 3});
          this.orginalName.push({
            serial: device.serial,
            name: device.name,
            alive: device.alive
          });
          await this.getDeviceData(device);
        })
      );


      await this.sortData();
      await this.sortArrayByName(this.data.devices, 'name');
      await this.sortArrayByName(this.selectedDevices, 'name');
      this.dataSource = new MatTableDataSource(this.data.devices);
      this.loading = false;
    }
  }

  async getDeviceData(device){

  // if (!device.serial.startsWith('A2') ){
    await this._devices.getMultiModules(device.serial, ['evsm', 'modulator', 'solar', 'rfid', 'schedman', 'spl', 'ocpp', 'sys'], 'all', true)
    .toPromise()
    .then(data => {
      data.forEach(module => {
        switch (module.topic_name) {
          case "evsm":
            device.evsmData = module.elements;
            break;
          case "modulator":
            device.modulator = module;
            break;
          case "solar":
            device.solar = module;
            break;
          case "rfid":
            device.rfid = module;
            break;
          case "schedman":
            device.scheduler = module.elements[0].data;
            if(module.elements.length > 1){
              device.scheduler2 = module.elements[1].data;
            }
            break;
          case "spl":
            device.spl = module;
            if ( module.cfg.splMode == 1){
              this.master = device.serial;
              this.masterName = device.name;
              this.powerLine = module.cfg.splLimitPower;
              const splLimitPowerByPhaseArray = JSON.parse(module.cfg.splLimitPowerByPhase);
              this.powerR = splLimitPowerByPhaseArray[0],
              this.powerS = splLimitPowerByPhaseArray[1],
              this.powerT = splLimitPowerByPhaseArray[2],
              this.chargeError = module.cfg.splSlaveFailPower


            }
            break;
          case "ocpp":
            device.ocpp = module;
            break;

          case "sys":
            device.sys = module;
            break;

          default:
            break;
        }
      });
    })
    .catch(error => console.error('Error fetching device data:', error));
  // }

    // if (device.serial.startsWith('A2') ) {
    //   await this._devices.getModuleInfo(device.serial, 'channel').toPromise().then(channelInfo => {
    //     device.channelInfo = channelInfo;
    //     console.log('channel info ', device.channelInfo);
    //     console.log('salida 1', device?.channelInfo?.stat.c1stat );
    //   });
    // }
  }


  sortArrayByName(array, key) {
    return array.sort((a, b) => {
        const valorA = key.split('.').reduce((o, k) => (o?.[k] ?? ""), a).toString().toLowerCase();
        const valorB = key.split('.').reduce((o, k) => (o?.[k] ?? ""), b).toString().toLowerCase();
        return valorA.localeCompare(valorB);
    });
  }

  checkTasks(tasks: string | any[]): boolean {
    let tasksParsed = typeof tasks === 'string' ? JSON.parse(tasks) : tasks;
    return tasksParsed.some((element: any) => element.initTime?.weekday != 0);
  }

  getNames(){
    this.orginalName = [];
    this.data.devices.forEach(element => {
      this.orginalName.push({
        serial: element.deviceInfo.serial,
        name: element.deviceInfo.name
      });
    });
  }

  getTranslatedText(translationKey: string) {
    if (translationKey)
      return this._translate.instant(translationKey);
    else
      return null;
  }


  updateBreadCrumbs(alias: string, index: number): void {
    const currentBreadCrumbs = this.breadCrumbs;
    const updatedBreadCrumbs = currentBreadCrumbs.slice(0, index +1);
    this._dashboard.replaceBreadCrumbs(updatedBreadCrumbs )
    if (index === 0) {
      this._dashboard.setModoDashboard('list')
      this._router.navigate(['dashboard']);
    } else {
      this._router.navigate(['dashboard/group', alias]);
    }
  }

  getLinkedDevices(subgroup){

    this._devices.getLinkedDevices(subgroup)
      .subscribe( data => {
          this.linkedDevices = data
      })
  }

  goToDevice(serial) {
    this._router.navigateByUrl(`/dashboard/device/${serial}`)
  }
  goToDiagnosis(serial : string){
      this._router.navigateByUrl(`/dashboard/device/${serial}/diagnosis`)
  }


  // goToSettings(serial) {
  //   this._router.navigateByUrl(`/dashboard/device/${serial}/settings`)
  // }

  changeName( serial: string ,name : string){

    this.orginalName.forEach(element => {
      if ( element.serial == serial  && element.name != name ) {
        const isConfirmed = confirm('Estas seguro de querer cambiar nombre del cargador ' + element.name + ' por ' + name  +' ?')
        if (isConfirmed) {
          element.name = name; // Realiza el cambio si el usuario acepta
          this._devices.setDeviceInfo(serial, {name: name} ).subscribe(() => {});
        } else {
            this.dataSource.filteredData.forEach(fila => {
              if ( fila.serial == serial){
                fila.name  = element.name
              }
            });

        }
      }
    });
  }

  buscarConn(serial: string) : any[] {
    let conns: any[] = []

    this.data.devices.forEach(element => {
      if( serial == element.serial ){
        element.element.forEach( conn => {
          conns.push(conn.name)
        })
      }
    }
  );

    return conns

  }


  ocpp() {
      this.confirm.ocpp = false;
      this.modalLoad = this._modal.open(LoadingPopupComponent);
      for (let index = 0; index < this.data.devices.length; index++) {
        if (this.selectedDevices[index].check){
          const body = {
            serverUrl: this.addBoxId && this.url !== '' ?  this.url + this.data.devices[index].serial : this.url,
            port: this.port
          };

          this._devices.setModuleCfg(this.data.devices[index].serial, body, 'ocpp')
            .subscribe(data => {
              this.status[index].status = 1;
            }, err => {
              console.error(err);
              this.status[index].status = 2;
            })
        }
      }
      setTimeout(() => {
        this.modalLoad.close();
        this.showStatus = true;
      }, 1000);
      setTimeout(() => {
        this.showStatus = false;
      }, 8000);
  }

  setRFID(){
    this.confirm.rfid = false;
    this.modalLoad=this._modal.open(LoadingPopupComponent);
    const body = {
      enabled: this.rfidEnabled,
      rfid: this.rfidMode,
      eocMode: this.eocMode
    };
    for (let index = 0; index < this.selectedDevices.length; index++) {
      if (this.selectedDevices[index].check){
        this._devices.setModuleCfg( this.selectedDevices[index].serial, body, 'rfid' )
        .subscribe( data => {
          this.status[index].status = 1
        }, err => {
          this.status[index].status = 2;
        } )
      }
    }
    setTimeout(() => {
      this.modalLoad.close();
      this.showStatus = true;
    }, 1000);
    setTimeout(() => {
      this.showStatus = false;
    }, 8000);
  }

  setWifi(){
    this.confirm.wifi = false;
    this.modalLoad=this._modal.open(LoadingPopupComponent);
  const body = {
    staEssid: this.ssid,
    staPasswd: this.wifiPass
  };
    for (let index = 0; index < this.selectedDevices.length; index++) {
      if (this.selectedDevices[index].check){
        this._devices.setModuleCfg( this.selectedDevices[index].serial, body, 'network' )
        .subscribe( data => {
          this.status[index].status = 1
        }, err => {
          this.status[index].status = 2;
        } )
      }
    }
    setTimeout(() => {
      this.modalLoad.close();
      this.showStatus = true;
    }, 1000);
    setTimeout(() => {
      this.showStatus = false;
    }, 8000);
  }

  setPassword(){
    this.confirm.password = false;
    this.modalLoad=this._modal.open(LoadingPopupComponent);
    const body = {
      apPasswd: this.newPass,
      apEnabled: this.accessPoint
    };
    for (let index = 0; index < this.selectedDevices.length; index++) {
      if (this.selectedDevices[index].check){
        this._devices.setModuleCfg( this.selectedDevices[index].serial, body, 'network' )
        .subscribe( data => {
          this.status[index].status = 1
        }, err => {
          this.status[index].status = 2;
        } )
      }
    }
    setTimeout(() => {
      this.modalLoad.close();
      this.showStatus = true;
    }, 1000);
    setTimeout(() => {
      this.showStatus = false;
    }, 8000);

  }

  toggleAllDevices(){
    this.selectedDevices.forEach(device => {
      device.check = this.selectAll;
    });
  }


  openModal(){
    this.chooseCfg = 'power';
    this.cancel();
  }

  cancel(){
    this.confirm = {
      power: false,
      reset: false,
      ocpp: false,
      rfid: false,
      wifi: false,
      password: false,
      cards: false,
      role: false
    };
    this.cardsMode = 'upload';
    this.messageDelCards = false;
  }

  checkAnyFieldTrue(): boolean {
    return Object.values(this.confirm).some(value => value === true);
  }

  messageConfirm(){
    if (this.confirm.power) return 'setPowerAll';
    if (this.confirm.reset) return 'resetAll';
    if (this.confirm.ocpp) return 'setOcppAll';
    if (this.confirm.rfid) return 'setRfidAll';
    if (this.confirm.wifi) return 'setWifiAll';
    if (this.confirm.password) return 'setPassAll';
    if (this.confirm.cards) return 'setCardsAll';
    if (this.confirm.role) return 'setRoleAll';
    return '';
  }

  changeMode(modo: string){
    if (modo === 'touch') {
      this.rfidEnabled = 1;
      this.rfidMode = 0;
    }

    if (modo === 'rfid') {
      this.rfidEnabled = 1;
      this.rfidMode = 1;
    }

    if (modo === 'off') {
      this.rfidEnabled = 0;
    }
  }

  setCards(modo :string ){
    this.confirm.cards = false;
    this.modalLoad=this._modal.open(LoadingPopupComponent);
    for (let index = 0; index < this.selectedDevices.length; index++) {
      if (this.selectedDevices[index].check){
        if ( modo === 'delete'){
          this._devices.deleteRfidListCard( this.selectedDevices[index].serial)
          .subscribe( data => {
            this.status[index].status = 1
          }, err => {
            this.status[index].status = 2;
          } )
        }else{
          this._devices.modifyRfidListCards( this.selectedDevices[index].serial , this.tagList)
          .subscribe( data => {
            this.status[index].status = 1
          }, err => {
            this.status[index].status = 2;
          } )
        }
      }
    }
    setTimeout(() => {
      this.modalLoad.close();
      this.showStatus = true;
    }, 1000);
    setTimeout(() => {
      this.showStatus = false;
    }, 8000);
  }



  sortData(){
    this.data.devices.sort((a, b) => {
      if(a.spl?.cfg && b.spl?.cfg){
        const modeA = a.spl.cfg.splMode;
        const modeB = b.spl.cfg.splMode;

        if (modeA === 1) return -1; // Coloca primero los 'splmode' con valor 1
        if (modeB === 1) return 1;

        if (modeA === 2) return -1; // Luego los 'splmode' con valor 2
        if (modeB === 2) return 1;
      }
      return 0; // Finalmente los 'splmode' con valor 0
    });

  }

  goToSPL(serial : string){
    if (this.master != ''){
      this._devices.setSelectedGroupDevices(this.data.devices);
      this._router.navigateByUrl(`/dashboard/device/${serial}/spl`)
    }
  }
  goTodetailGroup(group){
    this._router.navigate(['/dashboard/newgroup', group]);
  }

  infoGroup(group){
    this._dashboard.setBreadCrumbs({
      name: group.name,
      alias: group.alias
    });
    this._router.navigate(['/dashboard/group', group.alias]);
  }

  detailGroup(group){
    this._dashboard.setBreadCrumbs({
      name: group.name,
      alias: group.alias
    });
    this._router.navigate(['/dashboard/group', group.alias, 'settings']);
  }
sortTable(field: 'name' | 'estado' | 'icon' | 'firmware_version_name') {
  if (!this.data.devices) {
    return; // Evita errores si los datos aún no están cargados
  }

  this.sortField = field;
  this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';

  this.data.devices.sort((a, b) => {
    let valueA: any, valueB: any;

    switch (field) {
      case 'name':
        valueA = a.name?.toLowerCase() || '';
        valueB = b.name?.toLowerCase() || '';
        break;
      case 'estado':
        valueA = a.alive || 0;
        valueB = b.alive || 0;
        break;
      case 'icon':
        valueA = a.serial || '';
        valueB = b.serial || '';
        break;
      case 'firmware_version_name':
        valueA = a.firmware_version_name?.toLowerCase() || '';
        valueB = b.firmware_version_name?.toLowerCase() || '';
        break;
    }

    if (typeof valueA === 'string' && typeof valueB === 'string') {
      return this.sortDirection === 'asc'
        ? valueA.localeCompare(valueB)
        : valueB.localeCompare(valueA);
    }

    return this.sortDirection === 'asc'
      ? valueA - valueB
      : valueB - valueA;
  });

  this.dataSource.data = this.data.devices;
}

goToSettings(serial, component){
  this._router.navigate(['dashboard/device', serial, 'settings', component]);

}

  isRelaySchedulerDevice(device: any): boolean {
    return isRelaySchedulerDevice(device);
  }

  getRelayDeviceImage(device: any): string {
    return getRelayDeviceImage(device?.serial, device?.sub_type);
  }

  getNumPhases(device){
    if(device?.sys?.stat?.hwv_pot.includes("3PH") && device?.sys?.cfg?.phase!=1){
      return 3;
    }
    else{
      return 1;
    }
  }

  getDisplayedColumns():string[] {
    if(this.data.name.startsWith('ASTRO MCB')){
      return this.displayedColumnsANC2;
    }
    else if(this.data.name.startsWith('XEOLUM')){
      return this.displayedColumnsXLUM;
    }
    else if(this.data.name.startsWith('ANC+') || this.data.name.toLowerCase().startsWith('datalog')){
      return this.displayedColumnsANC1;
    }
    else{
      return this.displayedColumns;
    }
  }

}
